import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import FAQSchema from '../../FAQSchema';

const GSTCalculator = () => {
    const [amount, setAmount] = useState(25000);
    const [taxSlab, setTaxSlab] = useState(12);
    const [isGstExclusive, setIsGstExclusive] = useState(true);

    const calculateGST = () => {
        let gstAmount;
        let postGstAmount;
        if (isGstExclusive) {
            gstAmount = (amount * taxSlab) / 100;
            postGstAmount = amount + gstAmount;
        } else {
            gstAmount = (amount * taxSlab) / (100 + taxSlab);
            postGstAmount = amount;
        }
        return {
            gstAmount,
            postGstAmount,
        };
    };

    const { gstAmount, postGstAmount } = calculateGST();
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            question: 'What is the full form of GST?',
            answer: 'GST stands for Goods and Services Tax, a unified tax system applied to goods and services in India.',
          },
          {
            question: 'Who is required to pay GST?',
            answer: 'Consumers pay GST when purchasing goods and services, while businesses collect and remit the tax to the government.',
          },
          {
            question: 'How does GST differ from VAT?',
            answer: 'While VAT is applied at each stage of production, GST is a comprehensive indirect tax that replaces multiple central and state taxes across the supply chain in India.',
          },
          {
            question: 'What are the different GST rates in India?',
            answer: 'GST rates are typically classified into four slabs: 5%, 12%, 18%, and 28%, depending on the type of good or service.',
          },
          {
            question: 'Can I use a GST calculator for all purchases?',
            answer: 'Yes, the GST calculator can be used for both products and services to estimate applicable tax.',
          },
          {
            question: 'How do I calculate GST on a product?',
            answer: 'To calculate GST on a product, use the formula: GST Amount = Price × GST%.',
          },
          {
            question: 'What is the difference between GST exclusive and GST inclusive?',
            answer: 'GST exclusive prices do not include tax and require GST to be added, while GST inclusive prices already have the tax built into the total.',
          },
          {
            question: 'How does GST affect businesses?',
            answer: 'Businesses must collect GST on sales, pay it to the government, and can claim input tax credits on GST paid on their business purchases.',
          },
          {
            question: 'Can businesses claim input tax credits?',
            answer: 'Yes, businesses can claim input tax credits (ITC) for the GST paid on eligible business expenses, which reduces their tax payable.',
          },
          {
            question: 'Is GST applicable on services?',
            answer: 'Yes, GST applies to both goods and services in India.',
          },
          {
            question: 'What is IGST?',
            answer: 'Integrated Goods and Services Tax (IGST) is levied on inter-state transactions, i.e., transactions that occur between different Indian states.',
          },
          {
            question: 'How do I find the original price from a GST inclusive price?',
            answer: 'Use the formula: Original Price = Final Price ÷ (1 + GST%).',
          },
          {
            question: 'How do I remove GST from a final price?',
            answer: 'To remove GST, use: GST = Original Price - (Original Price × {100 / (100 + GST%)}).',
          },
          {
            question: 'Does GST apply to all goods and services?',
            answer: 'GST applies to most goods and services, though certain items like alcohol and petroleum are outside its scope or taxed differently.',
          },
          {
            question: 'Is GST only applicable to businesses in India?',
            answer: 'No, GST affects both businesses and consumers. Businesses are responsible for collecting and remitting it to the government.',
          },
        ];
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
    return (
        <>
        <Helmet>
         <title>GST Calculator – Calculate GST Amount Online</title>
        <meta  name='description' content='Use our GST calculator to determine the GST amount and net price for inclusive and exclusive GST calculations.'/>
        <meta name='keywords' content='gst calculation formula, gst tax calculator,easy gst calculator, calculate gst online, gst interest calculator, gst late fee calculator, gst rate finder' />
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/gst-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">GST Calculator</span>
        </li> 
      
      </ol>
    </nav>
            <div className='py-4'>
                <div className="container mx-auto p-4 max-w-8xl">
                    <div className="flex flex-wrap -mx-4">
                        <div className="w-full lg:w-2/3 px-4">
                            <h1 className="text-2xl font-bold mb-4">GST Calculator</h1>
                            <div className="bg-white shadow-md rounded p-6">
                                <div className="flex items-center mb-4">
                                    <div className="flex items-center mr-4">
                                        <input
                                            type="radio"
                                            id="gstExclusive"
                                            name="gstType"
                                            checked={isGstExclusive}
                                            onChange={() => setIsGstExclusive(true)}
                                            className="mr-2"
                                        />
                                        <label htmlFor="gstExclusive" className="text-gray-700 font-semibold">
                                            GST Exclusive
                                        </label>
                                        <Tooltip id="gstExclusive" content="GST will be added to the amount" />
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            id="gstInclusive"
                                            name="gstType"
                                            checked={!isGstExclusive}
                                            onChange={() => setIsGstExclusive(false)}
                                            className="mr-2"
                                        />
                                        <label htmlFor="gstInclusive" className="text-gray-700 font-semibold">
                                            GST Inclusive
                                        </label>
                                        <Tooltip id="gstInclusive" content="GST is already included in the amount" />
                                    </div>
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-semibold">Total amount</label>
                                    <div className="flex items-center">
                                        <input
                                            type="number"
                                            value={amount}
                                            onChange={(e) => setAmount(Number(e.target.value))}
                                            className="w-1/2 p-2 border rounded mr-2"
                                        />
                                        <span className="text-gray-700">₹ {amount.toLocaleString()}</span>
                                    </div>
                                    <input
                                        type="range"
                                        min="1000"
                                        max="1000000"
                                        value={amount}
                                        onChange={(e) => setAmount(Number(e.target.value))}
                                        className="w-full mt-2"
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-semibold">Tax slab</label>
                                    <div className="flex items-center">
                                        <input
                                            type="number"
                                            min="1"
                                            max="100"
                                            value={taxSlab}
                                            onChange={(e) => setTaxSlab(Number(e.target.value))}
                                            className="w-1/2 p-2 border rounded mr-2"
                                        />
                                        <span className="text-gray-700">{taxSlab} %</span>
                                    </div>
                                    <input
                                        type="range"
                                        min="1"
                                        max="100"
                                        value={taxSlab}
                                        onChange={(e) => setTaxSlab(Number(e.target.value))}
                                        className="w-full mt-2"
                                    />
                                </div>
                                <div className="mt-4 bg-green-100 p-4 rounded">
                                    <div className="flex justify-between items-center">
                                        <span className="font-semibold text-gray-700">Total GST:</span>
                                        <span className="text-xl font-bold text-gray-900">₹ {gstAmount.toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between items-center mt-2">
                                        <span className="font-semibold text-gray-700">Post-GST amount:</span>
                                        <span className="text-xl font-bold text-gray-900">₹ {postGstAmount.toLocaleString()}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full lg:w-1/3 px-4 mt-8 lg:mt-0 text-center">
                            <div className="bg-white shadow-md rounded p-6">
                                <h2 className="text-xl font-bold mb-4">Invest the way you want</h2>
                                <div className="mb-4">
                                    <img src="https://www.shutterstock.com/image-illustration/credit-cards-online-shopping-banner-260nw-355524626.jpg" alt="Banner" className="w-full rounded" />
                                </div>
                                <p>Join millions of Indians who trust and love TheFinMasters.</p>
                                <button className="bg-green-500 text-white px-4 py-2 rounded mt-4">Explore Products</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
            <div className="w-full md:w-2/3 p-4 mx-auto">
            <div className="container mx-auto py-4">
          <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            What is GST (Goods and Services Tax)?
          </h1>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Goods and Services Tax (GST) is an indirect tax that was implemented in India on July 1, 2017. It is designed to streamline the country’s tax system by replacing a range of previous taxes, such as sales tax, VAT (Value Added Tax), excise duty, and service tax, among others. GST is applied to the supply of goods and services, and it is a single, unified tax that applies at every stage of the production and distribution chain.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            The primary aim of GST is to create a single national market by eliminating cascading taxes (tax on tax) and simplifying the tax structure. Under the GST framework, both goods and services are taxed at different rates depending on their classification. This system helps ensure transparency, prevents tax evasion, and promotes ease of doing business by bringing more taxpayers under the formal tax regime.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Types of GST
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              There are four main types of GST in India:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>CGST (Central Goods and Services Tax):</strong> Levied by the central government on intra-state transactions (within the same state).</li>
              <li><strong>SGST (State Goods and Services Tax):</strong> Levied by the state government on intra-state transactions.</li>
              <li><strong>IGST (Integrated Goods and Services Tax):</strong> Levied by the central government on inter-state transactions (transactions between different states).</li>
              <li><strong>UGST (Union Territory Goods and Services Tax):</strong> Applicable in union territories, similar to SGST.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Who Pays GST?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              GST is a consumption-based tax, meaning that it is primarily paid by consumers at the time of purchasing goods and services. However, businesses play a key role in the collection and remittance of this tax to the government. Here's how it works:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Businesses and GST</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Every business that crosses a certain turnover threshold is required to register for GST with the government. They receive a GST Identification Number (GSTIN), which is used to track their GST obligations. Registered businesses collect GST from consumers on behalf of the government and remit it after claiming input tax credits (ITC) for taxes paid on their own purchases.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Consumers and GST</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Consumers are the ultimate end-users who bear the cost of GST when purchasing goods or services. Whether you're buying a product at a store or paying for services like consulting, entertainment, or hospitality, GST is added to the price. Consumers should be aware of how to calculate GST in order to make informed financial decisions.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              While businesses collect GST, it's the consumer who ultimately pays it. Understanding how much GST you’re paying allows you to evaluate the true cost of products or services and make more informed purchasing decisions.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Can a GST Calculator Help You?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A GST Calculator is an incredibly useful tool that simplifies the process of calculating GST on purchases. Whether you're an individual trying to understand the total cost of a purchase or a business owner calculating taxes for invoicing purposes, a GST calculator offers several benefits. Here's how it can help:
            </p>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Estimates GST on Purchases</strong><br />When you buy a product or service, GST is added to the base price. A GST calculator helps you instantly calculate the amount of GST being charged on a specific purchase. This is particularly useful when dealing with different GST rates for various types of goods and services.<br />For example, if you're buying a product with an 18% GST rate, the calculator will give you the exact tax amount so that you can see how much you’re paying in GST. This way, you don’t have to manually calculate the tax component, which can often be tedious and error-prone.</li>
              <li><strong>Saves Time</strong><br />Manually calculating GST for each purchase or invoice can be time-consuming, especially when dealing with complex tax structures or multiple items. A GST calculator automates this process, saving you time and effort. You simply enter the necessary details, and the calculator provides accurate results in seconds.</li>
              <li><strong>Empowers Informed Consumption</strong><br />Being aware of the GST component in the prices of goods and services helps you make informed purchasing decisions. If you know how much GST is included in the price, you can assess whether the price is competitive or if there are alternative products available at better rates.<br />For businesses, this is even more important, as understanding GST helps in compliance, pricing strategies, and invoicing. By using a GST calculator, you can ensure you're adhering to tax rules and avoid paying more than necessary.</li>
              <li><strong>Accuracy in Calculations</strong><br />Manual calculations can be prone to errors, especially when dealing with multiple tax slabs or when items are subject to varying GST rates. The GST calculator ensures accuracy in calculations, reducing the risk of mistakes that could lead to financial discrepancies or tax-related issues.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              GST Calculation Formulas
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Adding GST to the Price</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              When GST is added to the base price of a product, the formula is as follows:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Formula for Adding GST:</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              GST Amount = (Price × GST%)
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For example, if the price of a product is ₹500 and the applicable GST rate is 18%, the GST amount will be calculated as:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              GST = ₹500 × (18/100) = ₹90
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Thus, the final price of the product becomes ₹500 + ₹90 = ₹590.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Removing GST from the Price</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              If you know the final price (inclusive of GST) and want to find out the original price (exclusive of GST), you can use the formula below:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Formula for Removing GST:</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Original Price = Final Price ÷ (1 + GST%)
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For example, if the final price is ₹118 and the GST rate is 18%, the original price would be calculated as:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Original Price = ₹118 ÷ (1 + 18/100) = ₹100
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This method helps businesses and consumers understand the actual cost of a product without the added tax.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Using TheFinMaster GST Calculator Online
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The TheFinMaster GST Calculator is a user-friendly online tool that simplifies the process of GST calculation. Follow these simple steps to use it:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Steps to Use the GST Calculator:</strong>
            </p>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Visit the TheFinMaster Website:</strong> Head to the TheFinMaster website where the GST calculator is hosted.</li>
              <li><strong>Enter the Original Cost:</strong> Input the price of the product or service before GST is added.</li>
              <li><strong>Enter the GST Rate:</strong> Input the applicable GST rate for the product or service (e.g., 5%, 12%, 18%, or 28%).</li>
              <li><strong>Instant Results:</strong> The GST calculator will instantly show you the GST amount and the final price (inclusive of GST).</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This calculator works for both adding and removing GST and provides fast and accurate results for different types of transactions, making it a must-have tool for both businesses and consumers.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Understanding GST Inclusive vs. Exclusive Prices
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>GST Inclusive Price</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A GST inclusive price is the final price a consumer pays, which already includes the GST amount. In this case, the GST is bundled with the base price, and there's no need for additional calculations. This is commonly seen on receipts or invoices where the GST is already included.
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For instance, if a product costs ₹1,000 (including 18% GST), the GST component is part of that ₹1,000, and the consumer doesn’t need to calculate it separately.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>GST Exclusive Price</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A GST exclusive price refers to the price of a product or service before GST is added. To find the final price, you need to calculate the GST and then add it to the base price. Businesses typically display prices exclusive of GST for clarity, especially when selling B2B (business-to-business) goods and services.
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For example, if a product costs ₹1,000 exclusive of GST, and the applicable GST rate is 18%, the final price after GST will be ₹1,000 + ₹180 = ₹1,180.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Benefits of Using a GST Calculator
            </h1>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Transparency in Taxation</strong><br />The GST calculator helps you break down the tax component in the total price, allowing consumers and businesses to see exactly how much tax they’re paying. This level of transparency promotes trust and accountability in the tax system.</li>
              <li><strong>Saves Time and Effort</strong><br />By automating the process of GST calculation, the calculator saves you from having to do complex manual computations. It ensures you’re able to quickly calculate GST for any purchase or sale, saving both time and effort.</li>
              <li><strong>Protects Against Errors</strong><br />Manual calculations can often lead to errors, especially if the GST rates are not correctly applied or if the product involves multiple components. The GST calculator minimizes this risk and ensures accuracy in the results, reducing the chances of discrepancies in tax reporting.</li>
            </ul>
          </div>
        </div>

                <div className="w-full md:w-1/3 p-4">
                    <div className="bg-white shadow-md rounded-lg overflow-hidden">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
                            <h2 className="text-lg font-semibold ">Popular Categories</h2>
                        </div>
                        <div className="p-2 ">
                        <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
                                {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>

                </div>

            </div>
            <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h1 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default GSTCalculator;
